/* jshint esversion: 6 */
/* jshint ignore:start */
import openbox from "../Images/open-box.png";
import returnimg from "../Images/return.png";
import time from "../Images/time-24.png";
import mastercard from "../Images/master-card.png";
import logog from '../Images/logowithname.png';
import facebook from '../Images/facebook.png';
import instagram from '../Images/instagram.png';
import twitter from '../Images/twitter.png';
import youtube from '../Images/youtube.png';
import symbol from '../Images/symbol.png';
import visa from '../Images/visa.png';
import paypal from '../Images/paypal.png';
import amex from '../Images/amex.png';
import card from '../Images/card.png';
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useContext, useState } from "react";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import { useTranslation } from "react-i18next";
const Footer = () => {

    const { t } = useTranslation();

    const { BaseUrl } = useContext(MyContext);
    const [pageList, setPageList] = useState([]);

    const Navigate = useNavigate();

    useEffect(() => {
        axios.post(`${BaseUrl}/user_api/u_pagelist.php`)
            .then((res) => {
                // console.log("u_pagelist", res);
                setPageList(res.data.pagelist);
            })
            .catch((error) => {
                console.error("u_pagelist", error);
            });
    }, []);

    const HandleNavigate = (path) => {
        Navigate(path);
    };

    return (
        <div>
            <div className="width_container">
                <div className="footer">

                    <div className="section_1">
                        <div className="flex_box">
                            <img alt="open-box" src={openbox}></img>
                            <div className="">
                                <h4 className="font-bold">{t("Instant Ticket Delivery")}</h4>
                                <p style={{ fontSize: "14px" }}>{t("Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!")}</p>
                            </div>
                        </div>
                        <div className="flex_box">
                            <img alt="open-box" src={returnimg}></img>
                            <div className="">
                                <h4 className="font-bold">{t("Easy Cancellations")}</h4>
                                <p style={{ fontSize: "14px" }}>{t("Change of plans? Cancel or reschedule your booking within 15 days with flexible options.")}</p>
                            </div>
                        </div>
                        <div className="flex_box">
                            <img alt="open-box" src={time}></img>
                            <div className="">
                                <h4 className="font-bold">{t("24/7 Customer Support")}</h4>
                                <p style={{ fontSize: "14px" }}>{t("Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.")}</p>
                            </div>
                        </div>
                        <div className="flex_box">
                            <img alt="open-box" src={mastercard}></img>
                            <div className="">
                                <h4 className="font-bold">{t("Secure Payment")}</h4>
                                <p style={{ fontSize: "14px" }}>{t("Book your tickets safely using multiple secure payment methods, including credit and debit cards.")}</p>
                            </div>
                        </div>
                    </div>

                    <div style={{ marginTop: "10px" }} className="section_2">

                        <div style={{ justifyContent: "space-between", flexWrap: "wrap" }} className="flex_box">
                            <img width="180px" alt="MagicMate" src={logog}></img>
                            <div className="flex_box">
                                <img width="30px" height="30px" alt="facebook" src={facebook} />
                                <img width="30px" height="30px" alt="instagram" src={instagram} />
                                <img width="30px" height="30px" alt="twitter" src={twitter} />
                                <img width="30px" height="30px" alt="youtube" src={youtube} />
                            </div>
                        </div>

                        <div style={{ marginTop: "20px", alignItems: "start", justifyContent: "space-between", flexWrap: "wrap" }} className="flex_box">
                            <div className="w_30">
                                <h2 className="font-bold text-[20px]">{t("About Company")}</h2>
                                <p style={{ padding: "10px", fontSize: "14px", lineHeight: "20px" }}>{t("We make event planning simple and stress-free. Whether you're organizing a concert, conference, or private party, our platform connects you with top venues and services to bring your vision to life.")}</p>
                            </div>
                            <div className="w_15">
                                <h2 className="font-bold text-[20px]">{t("Help Information")}</h2>
                                <div style={{ fontSize: "15px", marginTop: "10px" }}>
                                    <p>{t("Shipping Information")}</p>
                                    <p>{t("Return & Refunds")}</p>
                                    <p>{t("Payment Options")}</p>
                                    <p><Link to="/faq">{t("FAQ")}</Link></p>
                                </div>
                            </div>
                            <div className="w_15">
                                <h2 className="font-bold text-[20px]">{t("Terms of Service")}</h2>
                                <div style={{ fontSize: "15px", marginTop: "10px" }}>
                                    {pageList.map((item, index) => {
                                        const Title = item.title.replace(/\s+/g, '_');
                                        const FinalText = Title.toLowerCase();
                                        return <p onClick={() => HandleNavigate(`/${FinalText}`)} key={index}>{item.title}</p>
                                    })}

                                </div>
                            </div>
                            <div className="w_15">
                                <h2 className="font-bold text-[20px]">{t("Account Information")}</h2>
                                <div style={{ fontSize: "15px", marginTop: "10px" }}>
                                    <p>{t("Login/Create Accoun")}t</p>
                                    <p><Link to="/booking">{t("Track Order")}</Link></p>
                                    <p><Link to="/favorite">{t("Favorites")}</Link></p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="section_3">
                        <p>{t("Copyright © 2025 MagicMate, All Rights Reserved.")}</p>
                        <div className="flex_box">
                            <img style={{ height: "25px", objectFit: "cover" }} alt="visa" src={symbol} />
                            <img style={{ height: "25px", objectFit: "cover" }} alt="visa" src={visa} />
                            <img style={{ height: "25px", objectFit: "cover" }} alt="visa" src={paypal} />
                            <img style={{ height: "25px", objectFit: "cover" }} alt="visa" src={amex} />
                            <img style={{ height: "25px", objectFit: "cover" }} alt="visa" src={card} />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Footer
/* jshint ignore:end */